import React from 'react';
import { useTranslation } from 'react-i18next';
import Papa from 'papaparse';

/**
 * CSV export of the comparison grid (bucket × series).
 * Uses papaparse (already a dep). Triggers a Blob download in-browser.
 */
export default function ExportButton({ seriesData, metric, alignPeriods, fileName = 'compare-anything' }) {
    const { t } = useTranslation();
    const onClick = () => {
        const csv = buildCsv(seriesData, metric, alignPeriods);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${fileName}-${new Date().toISOString().slice(0, 10)}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    return (
        <button type="button" onClick={onClick} className="v3-btn" style={{ fontSize: 12 }}>
            {t('Export CSV')}
        </button>
    );
}

function metricFieldKey(metric) {
    if (metric === 'transactions') return 'trans_count';
    if (metric === 'revenue') return 'revenue_share_amount';
    return 'sales';
}

function buildCsv(seriesData, metric, alignPeriods) {
    const fld = metricFieldKey(metric);
    if (!seriesData || seriesData.length === 0) return '';

    const labels = seriesData.map(s => s.label || `${s.type}:${s.id}`);
    const header = [alignPeriods ? 'Bucket' : 'Date', ...labels];
    const rows = [];

    if (alignPeriods) {
        const max = Math.max(...seriesData.map(s => (s.series || []).length));
        for (let i = 0; i < max; i++) {
            const row = [`#${i + 1}`];
            seriesData.forEach(s => {
                const r = (s.series || [])[i];
                row.push(r ? (r[fld] || 0) : '');
            });
            rows.push(row);
        }
    } else {
        const set = new Set();
        seriesData.forEach(s => (s.series || []).forEach(r => set.add(String(r._id))));
        const buckets = [...set].sort();
        buckets.forEach(b => {
            const row = [b];
            seriesData.forEach(s => {
                const r = (s.series || []).find(x => String(x._id) === b);
                row.push(r ? (r[fld] || 0) : '');
            });
            rows.push(row);
        });
    }

    return Papa.unparse({ fields: header, data: rows });
}
